import React, { FC, useState } from 'react';

import { Button, RowButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { ModalDialogType } from '@eika/modal';
import { RadioButtons } from '@eika/radio-button';

import type { ReceiptType } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';
import { arrayOfAll } from '../../../../utils/mapper/arrayOfAll';
import { EikaModal } from '../../../EikaModal';
import { StickyFooterRow } from '../../../shared/StickyFooter';

interface Props {
    locked?: boolean;
    onChange: (value: ReceiptType) => void;
    receiptType?: ReceiptType;
    animateModalAs?: ModalDialogType;
}

const receiptTypes = arrayOfAll<ReceiptType>()(['NONE', 'STICKER', 'PRINT']);

const ReceiptField: FC<Props> = ({ onChange, receiptType, animateModalAs, locked }) => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const selectOption = (value: string) => {
        const newValue = value as ReceiptType;
        onChange(newValue);
    };

    return (
        <>
            <RowButton
                disabled={locked}
                onClick={() => setShowModal(true)}
                className="date-field__button"
                data-testid="receipt-field"
            >
                <div className="date-field__layout">
                    <div className="date-field__label">
                        <span className="date-field__label">{translated.receipt.title}</span>
                        <span className="date-field__value">
                            {translated.receipt.receiptType[receiptType ?? 'NONE']}
                        </span>
                    </div>
                    <div className="date-field__icon">
                        {locked ? (
                            <Icon type={IconTypes.PIN_KODE_24} className="icon--24" ariaLabel="Låst" />
                        ) : (
                            <Icon type={IconTypes.LITEN_PIL_HOEYRE} className="icon--20" ariaLabel="Endre" />
                        )}
                    </div>
                </div>
            </RowButton>
            <EikaModal
                id="receipt-modal"
                open={showModal}
                setOpen={setShowModal}
                onSubmit={() => setShowModal(false)}
                animateAs={animateModalAs}
            >
                <RadioButtons
                    onChange={selectOption}
                    label={translated.receipt.title}
                    sublabel={translated.receipt.description}
                    selectedOption={receiptType ?? 'NONE'}
                    options={receiptTypes.map((type) => {
                        return { value: type, label: translated.receipt.receiptTypeVerbose[type] };
                    })}
                />
                <StickyFooterRow>
                    <Button size="small" onClick={() => setShowModal(false)}>
                        {translated.continue}
                    </Button>
                </StickyFooterRow>
            </EikaModal>
        </>
    );
};

export default ReceiptField;
